import api from './api';
import useAuthStore from '@/stores/auth';
function storageKey(kind, target) {
  const state = useAuthStore.getState();
  return `cervica.delivery.${state.tenant?.id || state.user?.tenant_id || 'tenant'}.${state.user?.id || 'user'}.${kind}.${target}`;
}
export function pendingDelivery(kind, target) {
  try { return localStorage.getItem(storageKey(kind, target)); } catch { return null; }
}
export function clearDelivery(kind, target, expectedId) { const key = storageKey(kind, target); if (!expectedId || localStorage.getItem(key) === expectedId) localStorage.removeItem(key); }
export function rememberDelivery(kind, target, id) { localStorage.setItem(storageKey(kind, target), id); }
export async function deliveryStatus(kind, target) {
  const id = pendingDelivery(kind, target);
  if (!id) return null;
  const { data } = await api.get(`/${kind === 'sms' ? 'messages' : 'crons'}/operations/${id}`);
  return data.operation;
}
export async function postDelivery(kind, target, path, payload) {
  const key = storageKey(kind, target);
  const existing = localStorage.getItem(key);
  if (existing) {
    // A different tab/reload must inspect the durable outcome first. Never
    // interpret a new click or a changed draft as authorization to resend.
    throw Object.assign(new Error('A previous delivery needs a status check before another send.'), { response: { status: 409, data: { error: 'Check the previous delivery status before sending again.', operation: { operation_id: existing, phase: 'unknown' } } } });
  }
  const operationId = crypto.randomUUID();
  localStorage.setItem(key, operationId); // capture account scope before awaiting network
  try {
    const response = await api.post(path, { ...payload, operation_id: operationId });
    const operation = response.data?.operation || response.data?.message?.delivery_operation;
    if (!operation || operation.operation_id !== operationId) throw new Error('Delivery receipt is incomplete.');
    if (operation.phase === 'confirmed') localStorage.removeItem(key);
    return response;
  } catch (error) {
    const recorded = error.response?.data?.operation;
    if (recorded?.phase === 'failed_no_action') localStorage.removeItem(key);
    else if (recorded?.operation_id) localStorage.setItem(key, recorded.operation_id);
    else if (error.response && error.response.status < 500 && error.response.status !== 409) localStorage.removeItem(key);
    throw error;
  }
}
